import React from "react";

const LOADING_GIF_URL = `${process.env.PUBLIC_URL || ""}/ta_loading150.gif`;

/**
 * Loading animation using the Twilanswer phone GIF.
 */
const LoadingAnimation = ({ className = "", style = {}, alt = "Loading", ...props }) => {
  const width = style.width ?? 48;
  const height = style.height ?? 48;

  return (
    <img
      src={LOADING_GIF_URL}
      alt={alt}
      className={className}
      style={{ width, height, display: "block", ...style }}
      {...props}
    />
  );
};

export default LoadingAnimation;
